<template>
<div>
    <contentCard :loading="loading">
        <template slot="cardContent">
            <div>
                <v-row justify="center" >
                    <v-col class="text-left col-md-6">
                        <div class="font-weight-bold body-1">
                            Detalles de la evaluación de desempeño
                        </div>
                    </v-col>
                </v-row> 
                <v-row justify="center">
                    <v-col cols="12" md="6" >

                        <details-item :detailsItems="items"></details-item>

                      
                        <v-divider></v-divider>

                      

                        <Separator v-if="evaluated.length > 0" title="Evaluados"></Separator>

                        <v-row>
                            <v-col> 
                                <div class="evaluations-evaluated-list" v-for="(item, index) in evaluated" :key="index">
                                    <span class="evaluations-evaluated-list-text">{{item.text}}</span>
                                </div>
                            </v-col>
                        </v-row>

                    </v-col>
                    
                </v-row>

            </div>

               <v-row justify="center" align="end">
                    <v-col cols="12" md="6" class="d-flex justify-end">
                        
                        <primary-button :props="cancelBtnData"></primary-button>
                    </v-col>
                </v-row>
        </template>
    </contentCard>
       
  </div>
</template>

<script>
import DetailsItem from '../../../components/DetailsItem.vue';
import Separator from '../../../components/Separator.vue';
// import Utils from '../../../helpers/Utils';
// import Utils from '../../../helpers/Utils';
export default {
    components: {
        DetailsItem,
        Separator,
    },
	data(){
		return {
            id: this.$route.params.id,
            loading: false,
            hasAttends: false,
            evaluated:[
            ],
           
            items: [
                
            ],
           
            cancelBtnData: {
                text: "Regresar",
                icon: "",
                to: "Evaluations",	
                block: false,
                click: () => {}
            },
       
          
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.index();
    },
	methods: {
        onResize () {
            
            if(window.innerWidth < 600){
                this.cancelBtnData.block = true;
            }
            else{
                this.cancelBtnData.block = false;
            }
        },
        method_handler(object){
			this[object.method_name](object.parameters)
		},
		validate () {
			return this.$refs.form.validate()
		},
        index(){
			//this.$store.state.overlay = true
			this.loading = true;
            this.$store.state.loading = true;
			this.$api.evaluation.get(this.id)
                .then((response) => {
                    // this.items.forEach((y) => {
                    //     y.valor = response.data[y.index]
                    // });
                    this.items= [
                        { concepto: 'Periodicidad', index: 'name', valor: this.getPeriodocity(response.data?.periodicity??'') },
                        { concepto: 'Periodo', index: 'name', valor: response.data.period },
                        { concepto: 'Evaluador', index: 'name', valor: response.data.evaluator.name },
                        
                    ];

                    this.evaluated = response.data.evaluated.map((x) => {
                        return {text: x.employee.name}
                    })
                    
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    this.$store.state.loading = false;
                })
            ;
		},
        getPeriodocity(value)
        {

            switch (value) {
                case 'MENSUAL':
                    return 'Mes';
                case 'BIMESTRAL':
                    return 'Bimestre';
                case 'TRIMESTRAL':
                    return 'Trimestre';
                case 'SEMESTRAL':
                    return 'Semestre';
                case 'ANUAL':
                    return 'Anual';
                default:
                    return '-'
            }
        },

        
    },
}
</script>

<style lang="scss">
    .v-skeleton-loader__text{
        margin-bottom: 0px;
    }
    .pre{
        white-space: pre-line;
    }

    .evaluations {
        &-evaluated-containter{
            display: flex;
        }



        &-evaluated-list{
            display: flex;
            justify-content: space-between;
            border-bottom: rgba(13, 13, 13, 0.145) solid 1px;


            &-text{
                align-content: center;
            }
        }
    }
    
</style> 